import { render } from "./DimensionInput.vue?vue&type=template&id=f606366c&scoped=true&ts=true"
import script from "./DimensionInput.vue?vue&type=script&lang=ts"
export * from "./DimensionInput.vue?vue&type=script&lang=ts"

import "./DimensionInput.vue?vue&type=style&index=0&id=f606366c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f606366c"]])

export default __exports__